var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHistory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5946 0C5.98569 0 2.18103 3.4744 1.65541 7.94118H0L2.11892 10.5882L4.23784 7.94118H2.72314C3.24136 4.0532 6.56049 1.05882 10.5946 1.05882C14.9893 1.05882 18.5405 4.60797 18.5405 9C18.5405 13.392 14.9893 16.9412 10.5946 16.9412C7.71476 16.9412 5.20093 15.4226 3.80743 13.136L2.93834 13.7316C4.52731 16.2924 7.3629 18 10.5946 18C15.5619 18 19.6 13.9643 19.6 9C19.6 4.03573 15.5619 0 10.5946 0ZM7.94595 10.0588H11.1243H11.6541V9.52941V5.82353V5.29412H10.5946V5.82353V9H7.94595",
    fill: "#FE273B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.6b7b37cdce37fe31713b2ab192e8e13b.svg";
export { ForwardRef as ReactComponent };